import { API_URL } from '@funnels/constants';
import { MOCK_INVITATION_FETCH_DATA, MOCK_INVITATION_VALIDITY_FETCH_DATA } from '@funnels/mockdata';

import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';
const isInitialInvite = localStorage.getItem('_lendi_funnels_debug_initial_invite') === 'true';
const INVITATIONS_URL = `${API_URL}/v1`;

function acceptInvitation(invitationId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve();
  }
  return axios.post(`${INVITATIONS_URL}/invitations/${invitationId}/accept`, {}).then((res) => res.data);
}

function cancelInvitation(invitationId: string, unauthorised?: boolean): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve();
  }
  const url = !unauthorised
    ? `${INVITATIONS_URL}/invitations/${invitationId}/cancel`
    : `${INVITATIONS_URL}/public/invitations/${invitationId}/cancel`;

  return axios.post(url, {});
}

function createInvitation(applicationId: string, applicantId: string, firstName: string, mobile: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: 'MOCK_INVITE_ID' });
  }
  return axios
    .post(`${INVITATIONS_URL}/applications/${applicationId}/invitations`, { applicantId, mobile, firstName })
    .then((res) => res.data);
}

function getInvitationValidity(invitationId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: MOCK_INVITATION_VALIDITY_FETCH_DATA });
  }
  return axios.get(`${INVITATIONS_URL}/public/invitations/${invitationId}/is-valid`).then((res) => res.data);
}

function fetchInvitations(applicationId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    const data = isInitialInvite ? [] : MOCK_INVITATION_FETCH_DATA;
    return Promise.resolve({ data });
  }
  return axios.get(`${INVITATIONS_URL}/applications/${applicationId}/invitations`).then((res) => res.data);
}

export default { acceptInvitation, cancelInvitation, createInvitation, getInvitationValidity, fetchInvitations };
